import _defineProperty from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/agent/_work/1/s/node_modules/@babel/runtime/regenerator/index.js";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { DefaultHttpClient } from "./DefaultHttpClient";
import { AggregateErrors, DisabledTransportError, FailedToNegotiateWithServerError, FailedToStartTransportError, HttpError, UnsupportedTransportError } from "./Errors";
import { HeaderNames } from "./HeaderNames";
import { LogLevel } from "./ILogger";
import { HttpTransportType, TransferFormat } from "./ITransport";
import { LongPollingTransport } from "./LongPollingTransport";
import { ServerSentEventsTransport } from "./ServerSentEventsTransport";
import { Arg, createLogger, getUserAgentHeader, Platform } from "./Utils";
import { WebSocketTransport } from "./WebSocketTransport";
var MAX_REDIRECTS = 100;
/** @private */
export var HttpConnection = /*#__PURE__*/function () {
  function HttpConnection(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, HttpConnection);
    this._stopPromiseResolver = function () {};
    this.features = {};
    this._negotiateVersion = 1;
    Arg.isRequired(url, "url");
    this._logger = createLogger(options.logger);
    this.baseUrl = this._resolveUrl(url);
    options = options || {};
    options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
    if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) {
      options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
    } else {
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    }
    options.timeout = options.timeout === undefined ? 100 * 1000 : options.timeout;
    var webSocketModule = null;
    var eventSourceModule = null;
    if (Platform.isNode && typeof require !== "undefined") {
      // In order to ignore the dynamic require in webpack builds we need to do this magic
      // @ts-ignore: TS doesn't know about these names
      var requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      webSocketModule = requireFunc("ws");
      eventSourceModule = requireFunc("eventsource");
    }
    if (!Platform.isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
      options.WebSocket = WebSocket;
    } else if (Platform.isNode && !options.WebSocket) {
      if (webSocketModule) {
        options.WebSocket = webSocketModule;
      }
    }
    if (!Platform.isNode && typeof EventSource !== "undefined" && !options.EventSource) {
      options.EventSource = EventSource;
    } else if (Platform.isNode && !options.EventSource) {
      if (typeof eventSourceModule !== "undefined") {
        options.EventSource = eventSourceModule;
      }
    }
    this._httpClient = options.httpClient || new DefaultHttpClient(this._logger);
    this._connectionState = "Disconnected" /* Disconnected */;
    this._connectionStarted = false;
    this._options = options;
    this.onreceive = null;
    this.onclose = null;
  }
  _createClass(HttpConnection, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transferFormat) {
        var message, _message;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              transferFormat = transferFormat || TransferFormat.Binary;
              Arg.isIn(transferFormat, TransferFormat, "transferFormat");
              this._logger.log(LogLevel.Debug, "Starting connection with transfer format '".concat(TransferFormat[transferFormat], "'."));
              if (!(this._connectionState !== "Disconnected" /* Disconnected */)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state.")));
            case 5:
              this._connectionState = "Connecting" /* Connecting */;
              this._startInternalPromise = this._startInternal(transferFormat);
              _context.next = 9;
              return this._startInternalPromise;
            case 9:
              if (!(this._connectionState === "Disconnecting" /* Disconnecting */)) {
                _context.next = 17;
                break;
              }
              // stop() was called and transitioned the client into the Disconnecting state.
              message = "Failed to start the HttpConnection before stop() was called.";
              this._logger.log(LogLevel.Error, message);
              // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
              _context.next = 14;
              return this._stopPromise;
            case 14:
              return _context.abrupt("return", Promise.reject(new Error(message)));
            case 17:
              if (!(this._connectionState !== "Connected" /* Connected */)) {
                _context.next = 21;
                break;
              }
              // stop() was called and transitioned the client into the Disconnecting state.
              _message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
              this._logger.log(LogLevel.Error, _message);
              return _context.abrupt("return", Promise.reject(new Error(_message)));
            case 21:
              this._connectionStarted = true;
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start(_x) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "send",
    value: function send(data) {
      if (this._connectionState !== "Connected" /* Connected */) {
        return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
      }
      if (!this._sendQueue) {
        this._sendQueue = new TransportSendQueue(this.transport);
      }
      // Transport will not be null if state is connected
      return this._sendQueue.send(data);
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this._connectionState === "Disconnected" /* Disconnected */)) {
                _context2.next = 3;
                break;
              }
              this._logger.log(LogLevel.Debug, "Call to HttpConnection.stop(".concat(error, ") ignored because the connection is already in the disconnected state."));
              return _context2.abrupt("return", Promise.resolve());
            case 3:
              if (!(this._connectionState === "Disconnecting" /* Disconnecting */)) {
                _context2.next = 6;
                break;
              }
              this._logger.log(LogLevel.Debug, "Call to HttpConnection.stop(".concat(error, ") ignored because the connection is already in the disconnecting state."));
              return _context2.abrupt("return", this._stopPromise);
            case 6:
              this._connectionState = "Disconnecting" /* Disconnecting */;
              this._stopPromise = new Promise(function (resolve) {
                // Don't complete stop() until stopConnection() completes.
                _this._stopPromiseResolver = resolve;
              });
              // stopInternal should never throw so just observe it.
              _context2.next = 10;
              return this._stopInternal(error);
            case 10:
              _context2.next = 12;
              return this._stopPromise;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function stop(_x2) {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "_stopInternal",
    value: function () {
      var _stopInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(error) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Set error as soon as possible otherwise there is a race between
              // the transport closing and providing an error and the error from a close message
              // We would prefer the close message error.
              this._stopError = error;
              _context3.prev = 1;
              _context3.next = 4;
              return this._startInternalPromise;
            case 4:
              _context3.next = 8;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
            case 8:
              if (!this.transport) {
                _context3.next = 21;
                break;
              }
              _context3.prev = 9;
              _context3.next = 12;
              return this.transport.stop();
            case 12:
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t1 = _context3["catch"](9);
              this._logger.log(LogLevel.Error, "HttpConnection.transport.stop() threw error '".concat(_context3.t1, "'."));
              this._stopConnection();
            case 18:
              this.transport = undefined;
              _context3.next = 22;
              break;
            case 21:
              this._logger.log(LogLevel.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 6], [9, 14]]);
      }));
      function _stopInternal(_x3) {
        return _stopInternal2.apply(this, arguments);
      }
      return _stopInternal;
    }()
  }, {
    key: "_startInternal",
    value: function () {
      var _startInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transferFormat) {
        var _this2 = this;
        var url, negotiateResponse, redirects, _loop;
        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // Store the original base url and the access token factory since they may change
              // as part of negotiating
              url = this.baseUrl;
              this._accessTokenFactory = this._options.accessTokenFactory;
              _context5.prev = 2;
              if (!this._options.skipNegotiation) {
                _context5.next = 13;
                break;
              }
              if (!(this._options.transport === HttpTransportType.WebSockets)) {
                _context5.next = 10;
                break;
              }
              // No need to add a connection ID in this case
              this.transport = this._constructTransport(HttpTransportType.WebSockets);
              // We should just call connect directly in this case.
              // No fallback or negotiate in this case.
              _context5.next = 8;
              return this._startTransport(url, transferFormat);
            case 8:
              _context5.next = 11;
              break;
            case 10:
              throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            case 11:
              _context5.next = 22;
              break;
            case 13:
              negotiateResponse = null;
              redirects = 0;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var accessToken;
                return _regeneratorRuntime.wrap(function _loop$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this2._getNegotiationResponse(url);
                    case 2:
                      negotiateResponse = _context4.sent;
                      if (!(_this2._connectionState === "Disconnecting" /* Disconnecting */ || _this2._connectionState === "Disconnected" /* Disconnected */)) {
                        _context4.next = 5;
                        break;
                      }
                      throw new Error("The connection was stopped during negotiation.");
                    case 5:
                      if (!negotiateResponse.error) {
                        _context4.next = 7;
                        break;
                      }
                      throw new Error(negotiateResponse.error);
                    case 7:
                      if (!negotiateResponse.ProtocolVersion) {
                        _context4.next = 9;
                        break;
                      }
                      throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    case 9:
                      if (negotiateResponse.url) {
                        url = negotiateResponse.url;
                      }
                      if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        accessToken = negotiateResponse.accessToken;
                        _this2._accessTokenFactory = function () {
                          return accessToken;
                        };
                      }
                      redirects++;
                    case 12:
                    case "end":
                      return _context4.stop();
                  }
                }, _loop);
              });
            case 16:
              return _context5.delegateYield(_loop(), "t0", 17);
            case 17:
              if (negotiateResponse.url && redirects < MAX_REDIRECTS) {
                _context5.next = 16;
                break;
              }
            case 18:
              if (!(redirects === MAX_REDIRECTS && negotiateResponse.url)) {
                _context5.next = 20;
                break;
              }
              throw new Error("Negotiate redirection limit exceeded.");
            case 20:
              _context5.next = 22;
              return this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            case 22:
              if (this.transport instanceof LongPollingTransport) {
                this.features.inherentKeepAlive = true;
              }
              if (this._connectionState === "Connecting" /* Connecting */) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log(LogLevel.Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* Connected */;
              }
              // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
              // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
              // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
              _context5.next = 33;
              break;
            case 26:
              _context5.prev = 26;
              _context5.t1 = _context5["catch"](2);
              this._logger.log(LogLevel.Error, "Failed to start the connection: " + _context5.t1);
              this._connectionState = "Disconnected" /* Disconnected */;
              this.transport = undefined;
              // if start fails, any active calls to stop assume that start will complete the stop promise
              this._stopPromiseResolver();
              return _context5.abrupt("return", Promise.reject(_context5.t1));
            case 33:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this, [[2, 26]]);
      }));
      function _startInternal(_x4) {
        return _startInternal2.apply(this, arguments);
      }
      return _startInternal;
    }()
  }, {
    key: "_getNegotiationResponse",
    value: function () {
      var _getNegotiationResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url) {
        var headers, token, _getUserAgentHeader, _getUserAgentHeader2, name, value, negotiateUrl, response, negotiateResponse, errorMessage;
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              headers = {};
              if (!this._accessTokenFactory) {
                _context6.next = 6;
                break;
              }
              _context6.next = 4;
              return this._accessTokenFactory();
            case 4:
              token = _context6.sent;
              if (token) {
                headers[HeaderNames.Authorization] = "Bearer ".concat(token);
              }
            case 6:
              _getUserAgentHeader = getUserAgentHeader(), _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2), name = _getUserAgentHeader2[0], value = _getUserAgentHeader2[1];
              headers[name] = value;
              negotiateUrl = this._resolveNegotiateUrl(url);
              this._logger.log(LogLevel.Debug, "Sending negotiation request: ".concat(negotiateUrl, "."));
              _context6.prev = 10;
              _context6.next = 13;
              return this._httpClient.post(negotiateUrl, {
                content: "",
                headers: _objectSpread(_objectSpread({}, headers), this._options.headers),
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
              });
            case 13:
              response = _context6.sent;
              if (!(response.statusCode !== 200)) {
                _context6.next = 16;
                break;
              }
              return _context6.abrupt("return", Promise.reject(new Error("Unexpected status code returned from negotiate '".concat(response.statusCode, "'"))));
            case 16:
              negotiateResponse = JSON.parse(response.content);
              if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
                // Negotiate version 0 doesn't use connectionToken
                // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
                negotiateResponse.connectionToken = negotiateResponse.connectionId;
              }
              return _context6.abrupt("return", negotiateResponse);
            case 21:
              _context6.prev = 21;
              _context6.t0 = _context6["catch"](10);
              errorMessage = "Failed to complete negotiation with the server: " + _context6.t0;
              if (_context6.t0 instanceof HttpError) {
                if (_context6.t0.statusCode === 404) {
                  errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
                }
              }
              this._logger.log(LogLevel.Error, errorMessage);
              return _context6.abrupt("return", Promise.reject(new FailedToNegotiateWithServerError(errorMessage)));
            case 27:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this, [[10, 21]]);
      }));
      function _getNegotiationResponse(_x5) {
        return _getNegotiationResponse2.apply(this, arguments);
      }
      return _getNegotiationResponse;
    }()
  }, {
    key: "_createConnectUrl",
    value: function _createConnectUrl(url, connectionToken) {
      if (!connectionToken) {
        return url;
      }
      return url + (url.indexOf("?") === -1 ? "?" : "&") + "id=".concat(connectionToken);
    }
  }, {
    key: "_createTransport",
    value: function () {
      var _createTransport2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        var connectUrl, transportExceptions, transports, negotiate, _iterator, _step, endpoint, transportOrError, message;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
              if (!this._isITransport(requestedTransport)) {
                _context7.next = 8;
                break;
              }
              this._logger.log(LogLevel.Debug, "Connection was provided an instance of ITransport, using that directly.");
              this.transport = requestedTransport;
              _context7.next = 6;
              return this._startTransport(connectUrl, requestedTransferFormat);
            case 6:
              this.connectionId = negotiateResponse.connectionId;
              return _context7.abrupt("return");
            case 8:
              transportExceptions = [];
              transports = negotiateResponse.availableTransports || [];
              negotiate = negotiateResponse;
              _iterator = _createForOfIteratorHelper(transports);
              _context7.prev = 12;
              _iterator.s();
            case 14:
              if ((_step = _iterator.n()).done) {
                _context7.next = 53;
                break;
              }
              endpoint = _step.value;
              transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
              if (!(transportOrError instanceof Error)) {
                _context7.next = 22;
                break;
              }
              // Store the error and continue, we don't want to cause a re-negotiate in these cases
              transportExceptions.push("".concat(endpoint.transport, " failed:"));
              transportExceptions.push(transportOrError);
              _context7.next = 51;
              break;
            case 22:
              if (!this._isITransport(transportOrError)) {
                _context7.next = 51;
                break;
              }
              this.transport = transportOrError;
              if (negotiate) {
                _context7.next = 35;
                break;
              }
              _context7.prev = 25;
              _context7.next = 28;
              return this._getNegotiationResponse(url);
            case 28:
              negotiate = _context7.sent;
              _context7.next = 34;
              break;
            case 31:
              _context7.prev = 31;
              _context7.t0 = _context7["catch"](25);
              return _context7.abrupt("return", Promise.reject(_context7.t0));
            case 34:
              connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
            case 35:
              _context7.prev = 35;
              _context7.next = 38;
              return this._startTransport(connectUrl, requestedTransferFormat);
            case 38:
              this.connectionId = negotiate.connectionId;
              return _context7.abrupt("return");
            case 42:
              _context7.prev = 42;
              _context7.t1 = _context7["catch"](35);
              this._logger.log(LogLevel.Error, "Failed to start the transport '".concat(endpoint.transport, "': ").concat(_context7.t1));
              negotiate = undefined;
              transportExceptions.push(new FailedToStartTransportError("".concat(endpoint.transport, " failed: ").concat(_context7.t1), HttpTransportType[endpoint.transport]));
              if (!(this._connectionState !== "Connecting" /* Connecting */)) {
                _context7.next = 51;
                break;
              }
              message = "Failed to select transport before stop() was called.";
              this._logger.log(LogLevel.Debug, message);
              return _context7.abrupt("return", Promise.reject(new Error(message)));
            case 51:
              _context7.next = 14;
              break;
            case 53:
              _context7.next = 58;
              break;
            case 55:
              _context7.prev = 55;
              _context7.t2 = _context7["catch"](12);
              _iterator.e(_context7.t2);
            case 58:
              _context7.prev = 58;
              _iterator.f();
              return _context7.finish(58);
            case 61:
              if (!(transportExceptions.length > 0)) {
                _context7.next = 63;
                break;
              }
              return _context7.abrupt("return", Promise.reject(new AggregateErrors("Unable to connect to the server with any of the available transports. ".concat(transportExceptions.join(" ")), transportExceptions)));
            case 63:
              return _context7.abrupt("return", Promise.reject(new Error("None of the transports supported by the client are supported by the server.")));
            case 64:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this, [[12, 55, 58, 61], [25, 31], [35, 42]]);
      }));
      function _createTransport(_x6, _x7, _x8, _x9) {
        return _createTransport2.apply(this, arguments);
      }
      return _createTransport;
    }()
  }, {
    key: "_constructTransport",
    value: function _constructTransport(transport) {
      switch (transport) {
        case HttpTransportType.WebSockets:
          if (!this._options.WebSocket) {
            throw new Error("'WebSocket' is not supported in your environment.");
          }
          return new WebSocketTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
        case HttpTransportType.ServerSentEvents:
          if (!this._options.EventSource) {
            throw new Error("'EventSource' is not supported in your environment.");
          }
          return new ServerSentEventsTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options);
        case HttpTransportType.LongPolling:
          return new LongPollingTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options);
        default:
          throw new Error("Unknown transport: ".concat(transport, "."));
      }
    }
  }, {
    key: "_startTransport",
    value: function _startTransport(url, transferFormat) {
      var _this3 = this;
      this.transport.onreceive = this.onreceive;
      this.transport.onclose = function (e) {
        return _this3._stopConnection(e);
      };
      return this.transport.connect(url, transferFormat);
    }
  }, {
    key: "_resolveTransportOrError",
    value: function _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat) {
      var transport = HttpTransportType[endpoint.transport];
      if (transport === null || transport === undefined) {
        this._logger.log(LogLevel.Debug, "Skipping transport '".concat(endpoint.transport, "' because it is not supported by this client."));
        return new Error("Skipping transport '".concat(endpoint.transport, "' because it is not supported by this client."));
      } else {
        if (transportMatches(requestedTransport, transport)) {
          var transferFormats = endpoint.transferFormats.map(function (s) {
            return TransferFormat[s];
          });
          if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
            if (transport === HttpTransportType.WebSockets && !this._options.WebSocket || transport === HttpTransportType.ServerSentEvents && !this._options.EventSource) {
              this._logger.log(LogLevel.Debug, "Skipping transport '".concat(HttpTransportType[transport], "' because it is not supported in your environment.'"));
              return new UnsupportedTransportError("'".concat(HttpTransportType[transport], "' is not supported in your environment."), transport);
            } else {
              this._logger.log(LogLevel.Debug, "Selecting transport '".concat(HttpTransportType[transport], "'."));
              try {
                return this._constructTransport(transport);
              } catch (ex) {
                return ex;
              }
            }
          } else {
            this._logger.log(LogLevel.Debug, "Skipping transport '".concat(HttpTransportType[transport], "' because it does not support the requested transfer format '").concat(TransferFormat[requestedTransferFormat], "'."));
            return new Error("'".concat(HttpTransportType[transport], "' does not support ").concat(TransferFormat[requestedTransferFormat], "."));
          }
        } else {
          this._logger.log(LogLevel.Debug, "Skipping transport '".concat(HttpTransportType[transport], "' because it was disabled by the client."));
          return new DisabledTransportError("'".concat(HttpTransportType[transport], "' is disabled by the client."), transport);
        }
      }
    }
  }, {
    key: "_isITransport",
    value: function _isITransport(transport) {
      return transport && typeof transport === "object" && "connect" in transport;
    }
  }, {
    key: "_stopConnection",
    value: function _stopConnection(error) {
      var _this4 = this;
      this._logger.log(LogLevel.Debug, "HttpConnection.stopConnection(".concat(error, ") called while in state ").concat(this._connectionState, "."));
      this.transport = undefined;
      // If we have a stopError, it takes precedence over the error from the transport
      error = this._stopError || error;
      this._stopError = undefined;
      if (this._connectionState === "Disconnected" /* Disconnected */) {
        this._logger.log(LogLevel.Debug, "Call to HttpConnection.stopConnection(".concat(error, ") was ignored because the connection is already in the disconnected state."));
        return;
      }
      if (this._connectionState === "Connecting" /* Connecting */) {
        this._logger.log(LogLevel.Warning, "Call to HttpConnection.stopConnection(".concat(error, ") was ignored because the connection is still in the connecting state."));
        throw new Error("HttpConnection.stopConnection(".concat(error, ") was called while the connection is still in the connecting state."));
      }
      if (this._connectionState === "Disconnecting" /* Disconnecting */) {
        // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
      }
      if (error) {
        this._logger.log(LogLevel.Error, "Connection disconnected with error '".concat(error, "'."));
      } else {
        this._logger.log(LogLevel.Information, "Connection disconnected.");
      }
      if (this._sendQueue) {
        this._sendQueue.stop().catch(function (e) {
          _this4._logger.log(LogLevel.Error, "TransportSendQueue.stop() threw error '".concat(e, "'."));
        });
        this._sendQueue = undefined;
      }
      this.connectionId = undefined;
      this._connectionState = "Disconnected" /* Disconnected */;
      if (this._connectionStarted) {
        this._connectionStarted = false;
        try {
          if (this.onclose) {
            this.onclose(error);
          }
        } catch (e) {
          this._logger.log(LogLevel.Error, "HttpConnection.onclose(".concat(error, ") threw error '").concat(e, "'."));
        }
      }
    }
  }, {
    key: "_resolveUrl",
    value: function _resolveUrl(url) {
      // startsWith is not supported in IE
      if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
        return url;
      }
      if (!Platform.isBrowser) {
        throw new Error("Cannot resolve '".concat(url, "'."));
      }
      // Setting the url to the href propery of an anchor tag handles normalization
      // for us. There are 3 main cases.
      // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
      // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
      // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
      var aTag = window.document.createElement("a");
      aTag.href = url;
      this._logger.log(LogLevel.Information, "Normalizing '".concat(url, "' to '").concat(aTag.href, "'."));
      return aTag.href;
    }
  }, {
    key: "_resolveNegotiateUrl",
    value: function _resolveNegotiateUrl(url) {
      var index = url.indexOf("?");
      var negotiateUrl = url.substring(0, index === -1 ? url.length : index);
      if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
        negotiateUrl += "/";
      }
      negotiateUrl += "negotiate";
      negotiateUrl += index === -1 ? "" : url.substring(index);
      if (negotiateUrl.indexOf("negotiateVersion") === -1) {
        negotiateUrl += index === -1 ? "?" : "&";
        negotiateUrl += "negotiateVersion=" + this._negotiateVersion;
      }
      return negotiateUrl;
    }
  }]);
  return HttpConnection;
}();
function transportMatches(requestedTransport, actualTransport) {
  return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
/** @private */
export var TransportSendQueue = /*#__PURE__*/function () {
  function TransportSendQueue(_transport) {
    _classCallCheck(this, TransportSendQueue);
    this._transport = _transport;
    this._buffer = [];
    this._executing = true;
    this._sendBufferedData = new PromiseSource();
    this._transportResult = new PromiseSource();
    this._sendLoopPromise = this._sendLoop();
  }
  _createClass(TransportSendQueue, [{
    key: "send",
    value: function send(data) {
      this._bufferData(data);
      if (!this._transportResult) {
        this._transportResult = new PromiseSource();
      }
      return this._transportResult.promise;
    }
  }, {
    key: "stop",
    value: function stop() {
      this._executing = false;
      this._sendBufferedData.resolve();
      return this._sendLoopPromise;
    }
  }, {
    key: "_bufferData",
    value: function _bufferData(data) {
      if (this._buffer.length && typeof this._buffer[0] !== typeof data) {
        throw new Error("Expected data to be of type ".concat(typeof this._buffer, " but was of type ").concat(typeof data));
      }
      this._buffer.push(data);
      this._sendBufferedData.resolve();
    }
  }, {
    key: "_sendLoop",
    value: function () {
      var _sendLoop2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var transportResult, data;
        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!true) {
                _context8.next = 22;
                break;
              }
              _context8.next = 3;
              return this._sendBufferedData.promise;
            case 3:
              if (this._executing) {
                _context8.next = 6;
                break;
              }
              if (this._transportResult) {
                this._transportResult.reject("Connection stopped.");
              }
              return _context8.abrupt("break", 22);
            case 6:
              this._sendBufferedData = new PromiseSource();
              transportResult = this._transportResult;
              this._transportResult = undefined;
              data = typeof this._buffer[0] === "string" ? this._buffer.join("") : TransportSendQueue._concatBuffers(this._buffer);
              this._buffer.length = 0;
              _context8.prev = 11;
              _context8.next = 14;
              return this._transport.send(data);
            case 14:
              transportResult.resolve();
              _context8.next = 20;
              break;
            case 17:
              _context8.prev = 17;
              _context8.t0 = _context8["catch"](11);
              transportResult.reject(_context8.t0);
            case 20:
              _context8.next = 0;
              break;
            case 22:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this, [[11, 17]]);
      }));
      function _sendLoop() {
        return _sendLoop2.apply(this, arguments);
      }
      return _sendLoop;
    }()
  }], [{
    key: "_concatBuffers",
    value: function _concatBuffers(arrayBuffers) {
      var totalLength = arrayBuffers.map(function (b) {
        return b.byteLength;
      }).reduce(function (a, b) {
        return a + b;
      });
      var result = new Uint8Array(totalLength);
      var offset = 0;
      var _iterator2 = _createForOfIteratorHelper(arrayBuffers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          result.set(new Uint8Array(item), offset);
          offset += item.byteLength;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result.buffer;
    }
  }]);
  return TransportSendQueue;
}();
var PromiseSource = /*#__PURE__*/function () {
  function PromiseSource() {
    var _this5 = this;
    _classCallCheck(this, PromiseSource);
    this.promise = new Promise(function (resolve, reject) {
      var _ref;
      return _ref = [resolve, reject], _this5._resolver = _ref[0], _this5._rejecter = _ref[1], _ref;
    });
  }
  _createClass(PromiseSource, [{
    key: "resolve",
    value: function resolve() {
      this._resolver();
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      this._rejecter(reason);
    }
  }]);
  return PromiseSource;
}();